(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexible-content"] && !Shopify.designMode) return;
  try {
    
  // 媒体轮播功能
  document.querySelectorAll('.fc-media-carousel').forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    
    if (track && prevBtn && nextBtn) {
      const scrollAmount = 300;
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => track.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
    }
    
    // 图片点击全屏
    carousel.querySelectorAll('[data-image-container]').forEach(container => {
      container.addEventListener('click', () => {
        const img = container.querySelector('img');
        if (img) openLightbox(img.src);
      });
    });
    
    // 视频点击播放
    carousel.querySelectorAll('[data-video-id]').forEach(btn => {
      btn.addEventListener('click', () => {
        const videoId = btn.dataset.videoId;
        if (videoId) openVideoLightbox(videoId);
      });
    });
  });
  
  function openLightbox(src) {
    const lightbox = document.createElement('div');
    lightbox.className = 'fc-lightbox';
    lightbox.innerHTML = `
      <button type="button" class="fc-lightbox__close" aria-label="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
      </button>
      <div class="fc-lightbox__content"><img src="${src}" alt="Full size"></div>
    `;
    document.body.appendChild(lightbox);
    document.body.style.overflow = 'hidden';
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.closest('.fc-lightbox__close')) {
        lightbox.remove();
        document.body.style.overflow = '';
      }
    });
  }
  
  function openVideoLightbox(videoId) {
    const lightbox = document.createElement('div');
    lightbox.className = 'fc-lightbox';
    lightbox.innerHTML = `
      <button type="button" class="fc-lightbox__close" aria-label="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
      </button>
      <div class="fc-lightbox__content">
        <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    `;
    document.body.appendChild(lightbox);
    document.body.style.overflow = 'hidden';
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.closest('.fc-lightbox__close')) {
        lightbox.remove();
        document.body.style.overflow = '';
      }
    });
  }

  // Banner Slider 功能
  document.querySelectorAll('.fc-banner-slider').forEach(slider => {
    const track = slider.querySelector('[data-slider]');
    const slides = track.querySelectorAll('.fc-banner-slider__slide');
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');
    const dotsContainer = slider.querySelector('[data-dots]');
    
    if (slides.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }
    
    let currentIndex = 0;
    
    // 创建 dots
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'fc-banner-slider__dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsContainer.appendChild(dot);
    });
    
    const dots = dotsContainer.querySelectorAll('.fc-banner-slider__dot');
    
    function goTo(index) {
      currentIndex = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, i) => dot.classList.toggle('active', i === currentIndex));
    }
    
    prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
    nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));
    
    // 自动播放
    setInterval(() => goTo(currentIndex + 1), 5000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  class ImageComparison {
    constructor(container) {
      this.container = container;
      this.slider = container.querySelector('[data-comparison-slider]');
      this.initialPosition = parseFloat(getComputedStyle(container).getPropertyValue('--slider-position')) || 50;
      
      this.init();
    }
    
    init() {
      // Hover event - slider follows mouse
      this.container.addEventListener('mousemove', this.onHover.bind(this));
      
      // Touch events for mobile
      this.container.addEventListener('touchmove', this.onTouch.bind(this), { passive: true });
    }
    
    onHover(e) {
      this.updatePosition(e.clientX);
    }
    
    onTouch(e) {
      if (e.touches && e.touches.length > 0) {
        this.updatePosition(e.touches[0].clientX);
      }
    }
    
    updatePosition(clientX) {
      const rect = this.container.getBoundingClientRect();
      let position = ((clientX - rect.left) / rect.width) * 100;
      position = Math.max(0, Math.min(100, position));
      
      this.container.style.setProperty('--slider-position', position + '%');
    }
  }
  
  // Initialize all comparison sliders
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-image-comparison]').forEach(function(container) {
      new ImageComparison(container);
    });
  });
  
  // Re-initialize on Shopify section load
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('[data-image-comparison]').forEach(function(container) {
        new ImageComparison(container);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function scrollToCollectionPanel(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    const headerOffset = 100;
    const y = el.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: y, behavior: 'instant' });
    return true;
  }

  function moveTabSectionIntoAnchor(contentSelector, anchorId) {
    const content = document.querySelector(contentSelector);
    const anchor = document.getElementById(anchorId);
    if (!content || !anchor || anchor.contains(content)) return false;

    const wrapper = content.closest('.shopify-section');
    anchor.appendChild(content);

    if (wrapper && wrapper.children.length === 0) {
      wrapper.remove();
    }

    const panel = anchor.closest('.collection-tabs__panel');
    if (panel) {
      panel.hidden = false;
      panel.classList.add('collection-tabs__panel--visible');
    }

    return true;
  }

  function moveTabSections() {
    moveTabSectionIntoAnchor('.collection-tab-craft', 'panel-craft-anchor');
    moveTabSectionIntoAnchor('.collection-tab-faq', 'panel-faq-anchor');
    moveTabSectionIntoAnchor('.collection-tab-reviews', 'panel-reviews-anchor');
    hideEmptyTabPanel('panel-craft-anchor', 'panel-craft');
    hideEmptyTabPanel('panel-faq-anchor', 'panel-faq');
    hideEmptyTabPanel('panel-reviews-anchor', 'panel-reviews');
  }

  function hideEmptyTabPanel(anchorId, panelId) {
    const anchor = document.getElementById(anchorId);
    const panel = document.getElementById(panelId);
    if (!anchor || !panel) return;
    if (!anchor.querySelector('.collection-tab-section')) {
      panel.hidden = true;
      panel.classList.remove('collection-tabs__panel--visible');
    }
  }

  // 进入类目页：不根据 URL hash 查找/滚动到指定 collection（人工配置的二级菜单可能对不上，会滚到底部）
  function clearEntryHashJump() {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    const id = hash.slice(1);
    if (
      id.startsWith('sub-collection-') ||
      id.startsWith('panel-') ||
      id.startsWith('tag-')
    ) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window.scrollTo(0, 0);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    clearEntryHashJump();
    moveTabSections();
  }, { once: true });

  } catch(e) { console.error(e); }
})();
})();
